import { useAuth } from 'hooks/useAuth';
import { columnsConfig, visibleColumnForSubsidyTransaction } from '../columnsConfig';

export default function useGetTableColumns() {
  const { userSettings } = useAuth();
  const selectedColumns = userSettings?.subsidyTransactionSettings?.selectedColumns || [];
  const availableColumnIds = columnsConfig.map(column => column.accessor);
  const visibleSelectedColumns = selectedColumns.filter(columnId =>
    availableColumnIds.includes(columnId)
  );

  return {
    defaultVisibleColumnIds: visibleColumnForSubsidyTransaction,
    visibleColumnIds:
      visibleSelectedColumns.length > 0
        ? visibleSelectedColumns
        : visibleColumnForSubsidyTransaction,
    availableColumns: columnsConfig
  };
}
